module.exports = __webpack_public_path__ + "static/media/slightly-agree.297d17c3.svg";